import _ from 'lodash';

/**
 * @param {Object} storeState - Redux root state
 * @returns {Object} Props for OwnOrganizationDashboard
 */
export default function selector(storeState) {
    const ownOrgState = _.get(storeState, 'adminV2.ownOrganization') ?? {};
    const { organization, users, isOrgLoading = true, isUsersLoading = true } = ownOrgState;
    const currentUserId = _.get(storeState, 'profile.userId');

    return {
        organization: organization ?? {},
        users: users ?? [],
        isOrgLoading,
        isUsersLoading,
        currentUserId,
    };
}
